import { Users } from "@phosphor-icons/react";

export function eQuadrant(u, i) {
  if (u && i) return "Do";
  if (!u && i) return "Schedule";
  if (u && !i) return "Delegate";
  return "Eliminate";
}

const QUADRANTS = [
  { u: true, i: true, title: "Do First", sub: "Urgent & Important", head: "bg-red-50 border-red-200 text-red-700" },
  { u: false, i: true, title: "Schedule", sub: "Important · Not Urgent", head: "bg-blue-50 border-blue-200 text-blue-700" },
  { u: true, i: false, title: "Delegate", sub: "Urgent · Not Important", head: "bg-amber-50 border-amber-200 text-amber-700" },
  { u: false, i: false, title: "Eliminate", sub: "Neither Urgent nor Important", head: "bg-slate-100 border-slate-200 text-slate-600" },
];

export default function EisenhowerBlueprint({ doc }) {
  const tasks = (doc.payload?.tasks || []).filter((t) => t.text?.trim());
  const inQuadrant = (q) => tasks.filter((t) => t.urgent === q.u && t.important === q.i);
  const delegated = tasks.filter((t) => (t.action || eQuadrant(t.urgent, t.important)) === "Delegate");

  return (
    <>
      {doc.payload?.context && <p className="mb-6 text-sm text-slate-500 max-w-2xl">{doc.payload.context}</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="matrix-grid">
        {QUADRANTS.map((q) => {
          const items = inQuadrant(q);
          return (
            <div key={q.title} data-testid={`quadrant-${q.title.toLowerCase().replace(/\s/g, "-")}`} className="border border-slate-200 rounded-sm bg-white overflow-hidden">
              <div className={`px-4 py-3 border-b ${q.head}`}>
                <p className="font-mono text-sm font-bold uppercase tracking-wide">{q.title}</p>
                <p className="text-xs opacity-80">{q.sub}</p>
              </div>
              <div className="p-4 min-h-[120px]">
                {items.length === 0 ? <p className="text-sm text-slate-300">— No tasks —</p> : (
                  <ul className="space-y-2">
                    {items.map((t) => (
                      <li key={t.id} className="flex items-start gap-2 text-sm text-slate-800">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0" />
                        <span>{t.text}{t.action && t.action !== eQuadrant(t.urgent, t.important) && <span className="ml-2 font-mono text-[10px] text-slate-400">→ {t.action}</span>}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8">
        <div className="flex items-center gap-2 mb-3">
          <Users size={18} weight="duotone" className="text-amber-600" />
          <h2 className="font-mono text-sm font-bold uppercase tracking-[0.1em] text-slate-700">Delegation Plan</h2>
        </div>
        {delegated.length === 0 ? (
          <p className="text-sm text-slate-400 border border-dashed border-slate-300 rounded-sm p-4 text-center">No delegated tasks.</p>
        ) : (
          <div className="bg-white border border-slate-200 rounded-sm overflow-hidden" data-testid="delegation-table">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
                  <th className="px-5 py-3 font-semibold">Task</th>
                  <th className="px-5 py-3 font-semibold">Accountable Owner</th>
                  <th className="px-5 py-3 font-semibold">Outcome & Authority</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {delegated.map((t) => (
                  <tr key={t.id}>
                    <td className="px-5 py-3.5 text-sm text-slate-800">{t.text}</td>
                    <td className="px-5 py-3.5 text-sm font-medium text-slate-900">{t.delegateTo || <span className="text-slate-300">— unassigned —</span>}</td>
                    <td className="px-5 py-3.5 text-sm text-slate-600">{t.notes || <span className="text-slate-300">—</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
